{
	"title": "Je moet inloggen",
	"description": "Om deze pagina te bekijken, is het noodzakelijk om ingelogd te zijn. Log in. Daarna word je doorgestuurd naar de gevraagde pagina.",
	"primaryButtonTitle": "Login openen"
}
